<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-radio-group v-model="radio" @change="change" class="radio-group">
                <el-col v-for="(item,index) in field['radio-list']" :key="index" class="image-set-radio-item">
                    <el-radio :label="item.value"><img :src="item.url" alt=""></el-radio>
                </el-col>
            </el-radio-group>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
    .radio-group {
        display: flex;
        flex-wrap: wrap;
        .radio-item {
            width: 120px;
            margin-bottom: 10px;
        }
    }
</style>

<script>

  import {mapGetters, mapMutations} from 'vuex'

  export default {
    name: 'tms-type-radio-box-img-set',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        radio: 1
      }
    },

    components: {},

    mounted() {
      if (!this.config[this.field.key]) {
        this.$set(this.config, this.field.key, 0);
      }
    },

    methods: {
      change(val) {
        this.config[this.field.key] = val;
        this.setImageStyleType(val);
      },
      ...mapMutations({
        'setImageStyleType': 'SET_IMAGE_STYLE_TYPE'
      })
    }
  }

</script>
